import { render, staticRenderFns } from "./DoctorCommentSection.vue?vue&type=template&id=3936714a&scoped=true"
import script from "./DoctorCommentSection.vue?vue&type=script&lang=js"
export * from "./DoctorCommentSection.vue?vue&type=script&lang=js"
import style0 from "./DoctorCommentSection.vue?vue&type=style&index=0&id=3936714a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936714a",
  null
  
)

export default component.exports